import './style.scss';

export default function BottomWave({className}){
    return (
        <div className="wave-container">
            <div className={`section-wave ${className}`} ></div>
        </div>
    );
}